import "./ScaffoldingInBracknell.module.css";
import Header from "@/reusable_sections/Header";
import HeroBracknell from "./sections/HeroBracknell";
import BracknellIntro from "./sections/BracknellIntro";
import BracknellCoverage from "./sections/BracknellCoverage";
import BracknellAccess from "./sections/BracknellAccess";
import Faq from "./sections/Faq";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInBracknellPage() {
  return <div>
      <Header />
      <HeroBracknell />
      <BracknellIntro />
      <BracknellCoverage />
      <BracknellAccess />
      <Faq />
      <Quote />
      <Footer />
    </div>;
}